import { render, staticRenderFns } from "./more.vue?vue&type=template&id=053f2705&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053f2705')) {
      api.createRecord('053f2705', component.options)
    } else {
      api.reload('053f2705', component.options)
    }
    module.hot.accept("./more.vue?vue&type=template&id=053f2705&", function () {
      api.rerender('053f2705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/more.vue"
export default component.exports